import H1, { H1Css } from "./H1";
import H2, { H2Css } from "./H2";
import H3, { H3Css } from "./H3";
import H4, { H4Css } from "./H4";
import H5, { H5Css } from "./H5";
export { H1, H2, H3, H4, H5, H1Css, H2Css, H3Css, H4Css, H5Css };
